import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateHTMLComponent } from "../../templates/template-html/template-html.component";

@Component({
  selector: "app-prefix-xxx",
  templateUrl: "./prefix-xxx.component.html",
  imports: [TemplateHTMLComponent],
  styleUrl: "./prefix-xxx.component.less",
})
export class PrefixXxxComponent extends PrefixComponent<string> {
  public constructor() {
    super();
    this.post = false;
    this.characters = ALLOWED_CHARACTERS["xxx"];
  }
}
